exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-0b7b7bab]{background-color:transparent!important;color:#ff5252;display:block}[data-v-0b7b7bab] .table-full .v-datatable.v-table>tbody{max-height:calc(100vh - 426px);min-height:calc(100vh - 426px)}", ""]);

// exports
